export default "__VITE_ASSET__254b290b__"